import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { serverResponse } from "../util/fakeServer";
import { isAllowedPath } from "../helper/utility";
import LoadingPages from "../views/Loading.pages";

const PrivateRoute = ({
  element: Element,
  authJWT: { isAuthenticated, loadingProfile },
  ...rest
}) => {
  const location = useLocation();

  if (
    serverResponse.config.allow_login &&
    serverResponse.config.only_logged &&
    loadingProfile
  ) {
    return <LoadingPages />;
  }

  if (
    serverResponse.config.allow_login &&
    serverResponse.config.only_logged &&
    !isAuthenticated &&
    !isAllowedPath(location.pathname)
  ) {
    return <Navigate to="/login" state={{ referrer: location.pathname }} replace />;
  }

  return <Element {...rest} />;
};

PrivateRoute.propTypes = {
  authJWT: PropTypes.object.isRequired,
  element: PropTypes.elementType.isRequired,
};

const mapStateToProps = (state) => ({
  authJWT: state.authJWT,
});

export default connect(mapStateToProps)(PrivateRoute);
